import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {select, Store} from '@ngrx/store';
import {TranslateService} from '@ngx-translate/core';
import {Observable} from 'rxjs';
import {
  citizenGetServicesDeliveryProcedureSteps
} from 'src/app/store/entities/citizens/citizens-services-delivery-procedure-steps/citizens-services-delivery-procedure-steps.actions';
import {
  CitizensServicesDeliveryProcedureSteps
} from 'src/app/store/entities/citizens/citizens-services-delivery-procedure-steps/citizens-services-delivery-procedure-steps.model';
import {
  selectModifiedServiceDeliveryProcedureSteps
} from 'src/app/store/entities/citizens/citizens-services-delivery-procedure-steps/citizens-services-delivery-procedure-steps.selectors';
import {
  ServiceDeliveryDuration
} from 'src/app/store/entities/service-management/service-delivery-duration/service-delivery-duration.model';
import {
  selectModifiedServiceDeliveryDurations
} from 'src/app/store/entities/service-management/service-delivery-duration/service-delivery-duration.selectors';
import {AppState} from 'src/app/store/reducers';

@Component({
  selector: 'app-citizen-services-delivery-procedure-steps',
  templateUrl: './citizen-services-delivery-procedure-steps.component.html',
  styleUrls: ['./citizen-services-delivery-procedure-steps.component.scss']
})
export class CitizenServicesDeliveryProcedureStepsComponent implements OnInit {

  @Input() serviceUniqueId: string;
  serviceSteps$:Observable<CitizensServicesDeliveryProcedureSteps []>;
  deliverySteps$: Observable<ServiceDeliveryDuration[]>


  totalYears = 0;
  totalMonths = 0;
  totalWeeks = 0;
  totalDays = 0;
  totalHours = 0;
  totalMinutes = 0;
  totalSeconds = 0;
  constructor(
    private store: Store<AppState>,
  ) {


    // this.store.dispatch(getServiceDeliveryDuration({serviceUniqueId: this.serviceUniqueId}))

  }

  ngOnInit(): void {
    this.store.dispatch(citizenGetServicesDeliveryProcedureSteps({serviceUniqueId:this.serviceUniqueId}));
    this.serviceSteps$ = this.store.select(selectModifiedServiceDeliveryProcedureSteps);
    this.deliverySteps$ = this.store.pipe(select(selectModifiedServiceDeliveryDurations))

    this.calculateTotalDeliveryDuration()

  }

  calculateTotalDeliveryDuration() {
    this.serviceSteps$.subscribe((durationSteps) => {
      if (durationSteps) {
        this.totalYears = 0
        this.totalMonths = 0
        this.totalWeeks = 0
        this.totalDays = 0
        this.totalHours = 0
        this.totalMinutes = 0
        this.totalSeconds = 0


        for (const durationStep of durationSteps) {
          if (durationStep.stepTimeInYear != 0) {
            this.totalYears += durationStep.stepTimeInYear
          }
          if (durationStep.stepTimeInMonths!= 0) {
            this.totalMonths += durationStep.stepTimeInMonths
          }
          if (durationStep.stepTimeInWeeks!= 0) {
            this.totalWeeks += durationStep.stepTimeInWeeks
          }
          if (durationStep.stepTimeInDays!= 0) {
            this.totalDays += durationStep.stepTimeInDays
          }
          if (durationStep.stepTimeInHours!= 0) {
            this.totalHours += durationStep.stepTimeInHours
          }
          if (durationStep.stepTimeInMinutes!= 0) {
            this.totalMinutes += durationStep.stepTimeInMinutes
          }
          if (durationStep.stepTimeInSec!= 0) {
            this.totalSeconds += durationStep.stepTimeInSec
          }
        }
      }
    })
  }

}
